import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const razorpayOrderApi = createAsyncThunk('razorpayOrder', async (payload) => {
    const response = await axiosInstance.post('/orders',payload);
    return response.data;
});

const razorpayOrderSlice = createSlice({
    name: "razorpayOrder",
    initialState: {
        data: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(razorpayOrderApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(razorpayOrderApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(razorpayOrderApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default razorpayOrderSlice.reducer;
